import { CheckoutContext } from '@/contexts/CheckoutContext';
import { usePrice } from '@/hooks/usePrice';
import { canPaymentMethodBePaidInInstallments } from '@/utils/payment';
import { useContext } from 'react';
import { useFormContext } from 'react-hook-form';
import { FormValues } from '../CheckoutForm';
import { InstallmentsSelector } from './InstallmentsSelector';

export function ApplePayForm() {
  const form = useFormContext<FormValues>();

  const { offer, hasAnySubscription } = useContext(CheckoutContext);

  const prices = usePrice({ form });

  // it will be removed when the api process all products in a single payment
  const priceToCalculateInstallments = hasAnySubscription
    ? prices.mainOfferPriceWithDiscount
    : prices.totalPriceWithDiscount;

  if (!canPaymentMethodBePaidInInstallments('applepay')) {
    return null;
  }

  return (
    !!offer && (
      <div className="flex w-full md:flex-1">
        <InstallmentsSelector
          itsNew
          offerPaid={!!offer.paid}
          fieldName="installments"
          calculatedInstallmentsFieldName="calculatedInstallments"
          offerId={offer.id}
          offerType={offer.type}
          price={priceToCalculateInstallments}
          recurrencePeriod={offer.recurrence_period}
        />
      </div>
    )
  );
}
